import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { BaseProductComponent } from '../base-product/base-product.component';

@Component({
  selector: 'app-pos-product',
  templateUrl: './pos-product.component.html',
  styleUrls: ['./pos-product.component.scss']
})
export class PosProductComponent extends BaseProductComponent {

  select = new FormControl();
  selectList: string[] = ['1', '2', '3', '4', '5'];

  despliegev = false;
  distanciaOk = true;
  active: boolean;
  cont = true;

  constructor(
    protected carroComprasService: CarroComprasService,
    protected marketplaceRedirectService: MarketplaceRedirectService,
    protected dialogService: DialogService,
    protected storageServ: LocalStorageService,
    protected tagM: TagManagerService,
    protected productoServiceVM: vmProductosService,
    protected localStorageService: LocalStorageService
    ) {
    super(carroComprasService,
      marketplaceRedirectService,
      dialogService,
      storageServ,
      tagM,
      productoServiceVM,
      localStorageService);
   }

  despliege() {
    this.despliegev = !this.despliegev;
    this.distancia = false;
    this.cont = !this.cont;
    this.isClicked = !this.isClicked;
  }

  on() {
    this.active = !this.active;
  }
}
